import { get } from 'lodash-es';
export function isUserPartOfThisCompany(state) {
    var companyId = get(state, 'project.config.companyData.id');
    return state.user.companyId === companyId;
}
export function isUserAuthenticated(state) {
    return state.user.isAuthenticated;
}
export function getUserRole(state) {
    return state.user.role;
}
